<template>
  <div>
    <div class="personal-data__container" v-if="!showArchive">
      <router-link class="gui-btn gui-btn--red gui-btn--w-207 u-margin-left-auto u-margin-b-24"
                   :to="{name: 'news-create'}"
                   v-if="canEdit">
        {{$t('form.news.add-news')}}
      </router-link>
    </div>
    <section class="personal-data__container">
      <div class="procurement a-main-content">
        <div class="procurement__liner">
          <div class="procurement__container-button">
            <router-link class="gui-btn gui-btn--collapse"
                         :class="{ 'gui-btn--collapse--active': !showArchive }"
                         :to="{ query: { ...$route.query, folder: 'active'  } }">
              {{$t('form.news.tabs.all-news')}}
            </router-link>
            <router-link class="gui-btn gui-btn--collapse"
                         :class="{ 'gui-btn--collapse--active': showArchive }"
                         :to="{ query: { ...$route.query, folder: 'archive' } }">
              {{$t('form.news.tabs.archive')}}
            </router-link>
          </div>
        </div>
        <div class="procurement__container">
          <news-list-item :id="item.id"
                          :title="item.title"
                          :publicationDate="item.publicationDate"
                          :briefDescription="item.briefDescription"
                          :from="item.from"
                          :to="item.to"
                          :key="item.id"
                          v-for="item in news">
          </news-list-item>
          <div class="table-tab a-width-100-percent" v-if="pages.length > 1">
            <div class="table-tab__nav">
              <nav>
                <ul class="pagination">
                  <li class="page-item prev">
                    <span class="page-link" @click="onPrevPageClick">
                      <img src="@/assets/img/static/arrow-next-prev.png" alt="">
                    </span>
                  </li>
                  <li class="page-item"
                      :class="{'active': p.active, 'disabled': p.disabled}"
                      v-for="p in pages">
                    <span class="page-link" @click="onPageClick(p)">{{p.label}}</span>
                  </li>
                  <li class="page-item next">
                    <span class="page-link" @click="onNextPageClick">
                      <img src="@/assets/img/static/arrow-next-prev.png" alt="">
                    </span>
                  </li>
                </ul>
              </nav>
              <div class="admin-buy__show-item">
                <p>{{$t('labels.show-by')}}</p>
                <dropdown-new class="select-w-77"
                          :options="pageSizes"
                          v-model="pageSize">
                </dropdown-new>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import NewsListItem from './NewsListItem'

  export default {
    components: {
      NewsListItem,
    },

    props: {
      showArchive: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      page: 1,
      pageSize: 5
    }),

    computed: {
      totalNews() {
        return this.$store.getters.news.total;
      },

      news() {
        return this.$store.getters.news.data;
      },

      pageSizes() {
        return [5, 10, 20, 50].map(e => ({
          id: e,
          name: e
        }));
      },

      totalPages() {
        return Math.ceil(this.totalNews / this.pageSize) || 0;
      },

      pages() {
        const minPage = Math.max(1, this.page - 4);
        const maxPage = Math.min(minPage + 10, this.totalPages);
        const pages = [];

        for (let id = minPage; id <= maxPage; ++id) {
          if (id === minPage && minPage !== 1) {
            pages.push({
              disabled: true,
              label: '...'
            });
          }
          else if (id === maxPage && maxPage !== this.totalPages) {
            pages.push({
              disabled: true,
              label: '...'
            });
          }
          else {
            pages.push({
              active: id === this.page,
              id: id,
              label: id
            })
          }
        }

        return pages;
      },

      canEdit() {
        const user = this.$store.getters.currentUser;
        return user && user.permissions.CAN_EDIT_NEWS;
      }
    },

    watch: {
      '$route'(){
        Object.assign(this.$data, this.$options.data.apply(this));
        this.fetchNews();
      },

      pageSize() {
        this.page = 1;
        this.fetchNews();
      }
    },

    created() {
      this.fetchNews();
    },

    methods: {
      fetchNews() {
        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchNews', {
              page: this.page,
              pageSize: this.pageSize,
              archive: this.showArchive
            });
          }
          catch(e) {
            console.error('unable to retrieve news', e);
            this.globalErrorHandler(e);
          }
        });
      },

      onPrevPageClick() {
        if (this.page > 1) {
          --this.page;
          this.fetchNews();
        }
      },

      onNextPageClick() {
        if (this.page < this.totalPages) {
          ++this.page;
          this.fetchNews();
        }
      },

      onPageClick(page) {
        if (!page.disabled && !page.active) {
          this.page = page.id;
          this.fetchNews();
        }
      },
    }
  }
</script>

<style scoped>

</style>
